module.exports = __webpack_public_path__ + "static/media/smurf.f3503255.png";